// import { DataUtil } from '@syncfusion/ej2-data';
// import { DataManager, UrlAdaptor } from '@syncfusion/ej2-data';

import logo from '../../static/images/beam-logo.png';
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import CustomSyncfusionFilter from '../../components/syncfusion/CustomSyncfusionFilter';
import { ButtonComponent } from '@syncfusion/ej2-react-buttons';
import AddCustomColumnDialog from '../../components/custom_fields/AddCustomColumnDialog';
import {
    GridComponent, ColumnsDirective, ColumnDirective, Page, ContextMenu,
    Inject, Group, Sort, Reorder, Edit, ExcelExport, Toolbar, Aggregate
} from '@syncfusion/ej2-react-grids';
import { DialogComponent } from '@syncfusion/ej2-react-popups'; // ButtonPropsModel, AnimationSettingsModel
import { MainPageButton } from '../../components/MainPageButton'

// import GridComponent from '../../components/GridComponent';
// import GridContextMenu from '../../components/GridContextMenu';
// import CustomColumnModal from '../../components/CustomColumnModal';
// import useRideSummary from '../hooks/useRideSummary';
// import useDueDate from '../hooks/useDueDate';

import { handleContextMenuOpen, handleContextMenuClick, contextMenuItems } from './grid/contextMenu'
import { editToolbar, exportToolbar, toolbarClick, excelFooterQueryCellInfo, excelHeaderQueryCellInfo, excelQueryCellInfo, beforeExcelExport, excelExportComplete } from './grid/toolbar'
import { useCustomColumns } from './grid/customColumns';
import { generateAggregatedColumns } from './grid/gridAggragate'
import { handleQueryCellInfo } from './grid/gridStyleControl'
import {
    loadLastTransactionRow, loadTransactionRows, generateCustomTransactionRows, checkIfIsDayDataOpen,
    deleteTransactionRows, populateGridWithCustomTransactionRows, populateGridWithLastTransactionRow
} from './grid/customTransactions'
import { ToastComponent } from '@syncfusion/ej2-react-notifications';

import '@syncfusion/ej2-base/styles/bootstrap.css';
import '@syncfusion/ej2-react-buttons/styles/bootstrap.css';
import '@syncfusion/ej2-react-grids/styles/bootstrap.css';
import '@syncfusion/ej2-react-inputs/styles/bootstrap.css';
import '@syncfusion/ej2-react-dropdowns/styles/bootstrap.css';
import '@syncfusion/ej2-react-popups/styles/bootstrap.css';
import '@syncfusion/ej2-react-navigations/styles/bootstrap.css';
import '@syncfusion/ej2-react-notifications/styles/bootstrap.css';
import './RidesPaymentCalculation.css';
import { isArray } from 'lodash';

function RidesPaymentCalculation() {
    const location = useLocation();
    const [data, setData] = useState([]);
    const [dataVersion, setDataVersion] = useState(0);
    const [isDayDataOpen, setOpenTag] = useState(undefined);
    const [selectedDate, setSelectedDate] = useState();
    const [dueDate, setDueDate] = useState();
    const [isWorkingHours, setWorkingHoursStatus] = useState(undefined);
    const [finalChartChecked, setFinalChartChecked] = useState(false);
    const [RideDateString, setRideDateString] = useState('');
    const [isModalOpen, setModalOpen] = useState(false);
    const [isConfirmationModalOpen, setConfirmationModalOpen] = useState(false);
    const [aggregatedColumns, setAggregatedColumns] = useState(null);
    const [toastInstance, setToastInstance] = useState(null);
    const toastPosition = { X: 'Right', Y: 'Bottom' };

    // Use the custom columns hook
    const {
        customColumns,
        setCustomColumns,
        balanceAndPayableColumnsCalc,
        percentageColumnValueCalc,
        populateInitialData_forCustomColumnField,
        generateColumnsForConfig,
        reAssignPercentageCalcFunction,
        getValidationRules,
        getPercentageCalcValue
    } = useCustomColumns();

    // let customColumns_copy;
    const org = process.env.REACT_APP_ORGANIZATION_NAME;

    const grid = useRef(null);

    useEffect(() => {
        // extract the 'date' parameter from the query string
        const queryParams = new URLSearchParams(location.search);
        const dateFromURL = queryParams.get('date');

        // validate the date
        if (dateFromURL && !isNaN(new Date(dateFromURL).getTime())) {
            setSelectedDate(dateFromURL);
        } else {
            setSelectedDate('');
            console.error("Invalid date from URL");
        }
    }, [location.search]);

    useEffect(() => {

        const fetchRideSummaryData = async () => {
            try {
                const response = await fetch(process.env.REACT_APP_RIDE_BACKOFFICE_SERVICE_URL + process.env.REACT_APP_RIDE_SUMMARY_ENDPOINT, {
                    method: 'POST',
                    headers: {
                        'accept': '*/*',
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        date: selectedDate
                    })
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                const resultData = await response.json();
                const newData = resultData.map((rowobj, index) => ({
                    ...rowobj,
                    row: index + 1,
                    rideDate: new Date(rowobj.rideDate),
                    driver: driverInfoForGridDisplay(rowobj.driver)
                }));
                return newData;

            } catch (error) {
                console.error("Failed to fetch ride summary:", error);
                return null;
            }
        };

        const fetchDueDate = async (strDate) => {
            try {
                const response = await fetch(process.env.REACT_APP_RIDE_BACKOFFICE_SERVICE_URL + process.env.REACT_APP_RIDE_DUEDATE_ENDPOINT, {
                    method: 'POST',
                    headers: {
                        'accept': '*/*',
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        dateString: strDate,
                        orgClosingTimeOfDay: process.env.REACT_APP_ORGANIZATION_CLOSING_TIME_OF_DAY
                    })
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                const resObj = await response.json();

                let resultDate;
                let workingHoursStatus = false;

                if (isArray(resObj)) {
                    [resultDate, workingHoursStatus] = resObj;
                } else {
                    resultDate = resObj;
                }

                setDueDate(resultDate);
                setWorkingHoursStatus(workingHoursStatus);
                return resultDate;

            } catch (error) {
                console.error("Failed to fetch due date default:", error);
                return null;
            }
        };

        const loadData = async () => {
            if (!isNaN(new Date(selectedDate).getTime())) {
                const newRideSummaryData = await fetchRideSummaryData();
                if (!newRideSummaryData) return;

                const objDate = new Date(selectedDate);
                const newRideDateString = `Rides Date: ${objDate.getMonth() + 1}/${objDate.getDate()}/${objDate.getFullYear()}`;
                setRideDateString(newRideDateString);

                const newDueDate = await fetchDueDate(newRideDateString);
                if (!newDueDate) return;

                loadTransactionRows(newDueDate)
                    .then(response => {
                        if (!response.ok) {
                            throw new Error('Failed to load transaction rows');
                        }
                        return response.json();
                    })
                    .then((transactionRows) => {
                        setOpenTag(checkIfIsDayDataOpen(transactionRows));
                        if (transactionRows?.length > 0 && transactionRows[0]?.ui?.customColumns) {
                            reAssignPercentageCalcFunction(transactionRows[0].ui.customColumns);
                            // console.log(transactionRows[0].ui.customColumns);
                            setCustomColumns(transactionRows[0].ui.customColumns);
                            populateGridWithCustomTransactionRows(newRideSummaryData, transactionRows);
                        } else if (transactionRows?.length < 1) {
                            loadLastTransactionRow()
                                .then(response => {
                                    if (!response.ok) {
                                        console.warn('Failed to load last transaction row!');
                                        return [];
                                    } else {
                                        return response.json();
                                    }
                                })
                                .then((lastTransactionRows) => {
                                    console.log(`After loadLastTransactionRow >> lastTransactionRows: `, lastTransactionRows);
                                    if (lastTransactionRows?.length > 0 && lastTransactionRows[0].ui?.customColumns) {
                                        // console.log(`After loadLastTransactionRow >> lastTransactionRows.ui?.customColumns: `, lastTransactionRows[0].ui?.customColumns);
                                        setCustomColumns(lastTransactionRows[0].ui.customColumns);
                                        reAssignPercentageCalcFunction(lastTransactionRows[0].ui.customColumns);
                                        populateGridWithLastTransactionRow(newRideSummaryData, lastTransactionRows);
                                    }
                                })
                        }

                        setData(newRideSummaryData);
                    })
                    .catch(error => {
                        console.error("Failed to load transaction rows:", error);
                    });
            } else {
                setRideDateString('');
            }
        }

        loadData();

    }, [selectedDate]);

    const updateAggregatedColumns = useCallback(() => {
        const newAggregatedColumns = generateAggregatedColumns(customColumns);
        // console.dir(`updateAggregatedColumns >> newAggregatedColumns: ${JSON.stringify(newAggregatedColumns)}`);
        setAggregatedColumns(newAggregatedColumns);
    }, [customColumns]);

    useEffect(() => {
        updateAggregatedColumns();
        setDataVersion(prevVersion => prevVersion + 1);
    }, [updateAggregatedColumns]);

    const handleGridDataBound = () => {
        if (grid.current) {
            const headerContent = grid.current.getHeaderContent();
            const footerContent = grid.current.getFooterContent();
            if (footerContent) headerContent.append(footerContent);
        }
    }

    const handleFinalChartToggle = () => {
        setFinalChartChecked(!finalChartChecked);
    };

    const gridEditOptions = { allowEditing: true, allowAdding: false, allowDeleting: false, mode: 'Normal' };//, mode: 'Batch' };

    const driverTemplate = (props) => {
        let value = props.driver;//.replace(/\n/g, "<br>");
        return <div dangerouslySetInnerHTML={{ __html: value }}></div>;
    };

    const driverInfoForGridDisplay = (val) => {
        if (!val) return '';
        return val.replace(/\n/g, "<br>");
    };


    const handleAddColumnClick = () => {
        setModalOpen(true);
    };

    const handleModalClose = () => {
        setModalOpen(false);
    };

    const handleAddColumn = (newColumnConfig) => {
        const { fieldName, newColumnsForGrid } = generateColumnsForConfig(newColumnConfig);

        // Add fieldName to the column configuration
        const updatedColumnConfig = {
            config: { ...newColumnConfig, fieldName },
            gridColumns: newColumnsForGrid
        };

        // Populate data for the new column
        const updatedData = populateInitialData_forCustomColumnField(data, updatedColumnConfig);

        // Update the state
        setCustomColumns(prevColumns => [...prevColumns, updatedColumnConfig]);
        setData(updatedData);
        setModalOpen(false);
    };

    const handleSaveTheGrid = () => {
        saveTheGrid();
    }

    const saveTheGrid = (closeTransactions = false) => {
        toastInstance.show({ content: 'Saving...', title: 'Saving Data', cssClass: 'e-toast-info' });

        deleteTransactionRows(dueDate)
            .then(response => {
                if (!response.ok) {
                    throw new Error('Failed to delete old rows');
                }
                return response.json();
            })
            .then(() => {
                const customTransactionRows = generateCustomTransactionRows(data, closeTransactions, dueDate, customColumns, percentageColumnValueCalc);

                const apiUrl = process.env.REACT_APP_RIDE_BACKOFFICE_SERVICE_URL + process.env.REACT_APP_RIDE_CUSTOM_TRANSACTION_BULK_ENDPOINTS;
                return fetch(apiUrl, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(customTransactionRows),
                });
            })
            .then(response => response.json())
            .then(data => {
                // console.log('Success:', data);
                if (closeTransactions) {
                    setOpenTag(false);
                    InMemoryCloseAllTheRows();
                }
                // Show success toast
                toastInstance.show({ content: `Data saved${closeTransactions ? ' and finilized' : ''} successfully!`, title: 'Success', cssClass: 'e-toast-success' });
            })
            .catch(error => {
                console.error('Error:', error);

                // Show error toast
                toastInstance.show({ content: `Failed to save: ${error.message}`, title: 'Error', cssClass: 'e-toast-danger' });
            });
    }

    function saveAndConfirm() {
        setConfirmationModalOpen(true);
    }

    function handleConfirmation(isConfirmed) {
        setConfirmationModalOpen(false); // Close the modal dialog
        if (isConfirmed) {
            // console.log("Data marked as final");
            saveTheGrid(true);
        } else {
            // console.log("Operation cancelled by user");
        }
    }
    function handleDialogClose() {
        setConfirmationModalOpen(false);
    }

    const rowNumberTemplate = (props) => {
        return <span>{parseInt(props.index) + 1}</span>;
    };

    function InMemoryCloseAllTheRows() {
        if (!data || data.length < 1) return;
        const newData = data;
        for (let row of newData) {
            const fieldNames = Object.keys(row);
            if (fieldNames.length < 1) return;
            let fieldName = fieldNames[0];
            if (!fieldName) fieldName = "dummyField";
            row[`${fieldName}_closed`] = true;
        }
        setData(newData);
    }

    function handleActionBegin(args) {
        if (args.requestType === 'beginEdit') {
            // Get an array of field names from args.rowData
            const fieldNames = Object.keys(args.rowData);

            // Iterate over each field name
            for (let FieldName of fieldNames) {
                const closedFieldName = `${FieldName}_closed`;
                // Check if the closedFieldName exists and is true
                if (args.rowData.hasOwnProperty(closedFieldName) && args.rowData[closedFieldName]) {
                    args.cancel = true;  // Cancel the editing process for the entire row
                    toastInstance.show({
                        content: `The data for this row has been finalized and locked, hence editing is no longer permitted.`,
                        title: 'Locked!',
                        cssClass: 'e-toast-warning'
                    });
                    return;  // This will now exit the handleActionBegin function entirely
                }
            }
        }
    }

    const handleActionComplete = (args) => {

        if (args.requestType === 'save') {

            // console.log(`handleActionComplete >> args.requestType: ${args.requestType} , args:`, args);
            //console.log(`handleActionComplete >> args.requestType: ${args.requestType} , data -->`, data);

            // Find the edited fields by comparing args.data and args.previousData
            const editedFields = Object.keys(args.data).filter(key => args.data[key] !== args.rowData[key]);

            // console.log(`Edited Fields: ${editedFields}`);
            // editedFields.map(fieldname => {
            //     // console.log(`${fieldname} -> '${args.data[fieldname]}' !== '${args.rowData[fieldname]}'`);
            //     return fieldname;
            // });

            // If there are edited fields, process them
            if (editedFields.length) {
                let SomeDataHasBeenChanged = false;
                let updatedData = data;
                editedFields.forEach(editedField => {
                    // Find the matching custom column based on the edited field and its uniformValues property
                    const matchedColumn = customColumns.find((column) => {
                        const ccFieldName = column.config.fieldName;
                        return ccFieldName === editedField && column.config.uniformValues;
                    });

                    if (matchedColumn) {
                        SomeDataHasBeenChanged = true;
                        const updatedValue = args.data[editedField];
                        // console.log(`Updating all rows for field ${editedField} to value ${updatedValue}`);

                        // Update all rows in the data with the new value for the edited column
                        updatedData = updatedData.map(row => {
                            return { ...row, [editedField]: updatedValue };
                        });
                    }
                });
                if (SomeDataHasBeenChanged) {
                    // Set the updated data
                    setData(updatedData);
                    setDataVersion(prevVersion => prevVersion + 1);

                    // Prepare feedback for user
                    const uniqueEditedColumns = Array.from(new Set(editedFields.map(field => customColumns.find(column => column.config.fieldName === field)?.config.caption)));
                    const fieldsText = uniqueEditedColumns.length === 1 ? 'column' : 'columns';
                    const columnsUpdatedText = uniqueEditedColumns.join(', ');
                    const toastContent = `Updated ${fieldsText}: ${columnsUpdatedText} in all rows due to uniform column value change.`;

                    // Show toast
                    toastInstance.show({ content: toastContent, title: 'Data Updated', cssClass: 'e-toast-info' });

                }
            }
        }
    };

    const DataOpenControls = () => (
        <>
            <div className="filter-item">
                <ButtonComponent onClick={handleAddColumnClick}>Add Column</ButtonComponent>
            </div>
            <div className="filter-item">
                <ButtonComponent onClick={handleSaveTheGrid}>Save The Grid</ButtonComponent>
            </div>
            <div className="filter-item">
                <ButtonComponent onClick={saveAndConfirm}>Confirm as Final</ButtonComponent>
            </div>
        </>
    );

    const DataClosedControls = () => (
        <div className="filter-item">
            <span>This day's data has been closed and is final.</span>
        </div>
    );

    const CurrentDayWorkingHourseControls = () => (
        <div className="filter-item">
            <span>Working hours ongoing; chart for observation only.</span>
        </div>
    );

    const FinalChartCheckbox = ({ checked, onChange }) => (
        <div className="filter-item">
            <input
                type="checkbox"
                id="finalChartCheckbox"
                checked={checked}
                onChange={onChange}
            />
            <label htmlFor="finalChartCheckbox">Simple Chart</label>
        </div>
    );

    return (
        <div className="RidesPaymentCalculation">
            <div className="payment-page-header">
                <img src={logo} className="payment-page-logo" alt="logo" />
                <h2>{org} Rides Payments Calculation</h2>
            </div>

            <ToastComponent ref={toast => setToastInstance(toast)} width='310px' position={toastPosition} />

            <div className="filter-container">
                <div className="filter-inner-container">
                    <div className="custom-filters">

                        <div className="filter-item">
                            <MainPageButton />
                        </div>

                        <div className="filter-item">
                            <span>{RideDateString}</span>
                        </div>

                        {isDayDataOpen === true && isWorkingHours === false && <DataOpenControls />}
                        {isDayDataOpen === true && isWorkingHours === true && <CurrentDayWorkingHourseControls />}
                        {isDayDataOpen === false && <DataClosedControls />}
                        {isDayDataOpen === false && <FinalChartCheckbox checked={finalChartChecked} onChange={handleFinalChartToggle} />}
                    </div>
                </div>
            </div>

            <div className="grid-container">
                <GridComponent
                    key={`theMainPaymentDataGrid_${finalChartChecked ? 'chartView' : 'normalView'}__${dataVersion}`}
                    id='grid'
                    className="gridcomponent"
                    dataSource={data}
                    rowHeight={50}
                    contextMenuItems={contextMenuItems}
                    contextMenuOpen={(args) => handleContextMenuOpen(args, grid, customColumns, isDayDataOpen === true && isWorkingHours === false)}
                    contextMenuClick={(args) => handleContextMenuClick(args, customColumns, setCustomColumns)}
                    editSettings={gridEditOptions}
                    ref={grid}
                    gridLines={'Both'}
                    queryCellInfo={(args) => handleQueryCellInfo(args)}
                    toolbar={(isDayDataOpen === true && isWorkingHours === false) ? [...editToolbar] : isDayDataOpen === false ? [...exportToolbar] : ['']}
                    toolbarClick={(args) => toolbarClick(args, grid, selectedDate)}
                    allowExcelExport={true}
                    excelQueryCellInfo={(args) => excelQueryCellInfo(args, grid, balanceAndPayableColumnsCalc, getPercentageCalcValue)}
                    excelHeaderQueryCellInfo={excelHeaderQueryCellInfo}
                    excelFooterQueryCellInfo={excelFooterQueryCellInfo}
                    excelExportComplete={excelExportComplete}
                    beforeExcelExport={beforeExcelExport}
                    allowTextWrap={true}
                    allowReordering={false}
                    allowSorting={false}
                    allowFiltering={true}
                    actionBegin={handleActionBegin}
                    dataBound={handleGridDataBound}
                    actionComplete={handleActionComplete}
                // enableImmutableMode={false}
                // enableHtmlSanitizer={true}
                // enableStickyHeader={true}
                >
                    <ColumnsDirective>
                        <ColumnDirective
                            template={rowNumberTemplate}
                            headerText='Row'
                            field='Row'
                            width='40'
                            allowEditing={false}
                            textAlign='Center'
                        />

                        <ColumnDirective
                            field="driverUserId"
                            headerText="User ID"
                            width='50'
                            allowEditing={false}
                            textAlign="Center"
                            isPrimaryKey={true}
                            visible={false}
                        />

                        <ColumnDirective
                            field="driverCustomID"
                            headerText="Driver ID"
                            width='50'
                            allowEditing={false}
                            filter={{ type: 'Menu', operator: 'contains' }}
                            textAlign="Center"
                        />

                        <ColumnDirective
                            field="driver"
                            headerText="Driver Info"
                            width='100'
                            textAlign='Center'
                            allowEditing={false}
                            filter={{ type: 'Menu', operator: 'contains' }}
                            template={driverTemplate}
                            disableHtmlEncode={true}
                            visible={!finalChartChecked}
                        />

                        <ColumnDirective
                            field="driverFullName"
                            headerText="Full Name"
                            width='100'
                            textAlign='Center'
                            filter={{ type: 'Menu', operator: 'contains' }}
                            allowEditing={false}
                            visible={finalChartChecked}
                        />

                        <ColumnDirective
                            field="driverPhone"
                            headerText="Phone"
                            width='100'
                            textAlign='Center'
                            filter={{ type: 'Menu', operator: 'contains' }}
                            allowEditing={false}
                            visible={finalChartChecked}
                        />

                        <ColumnDirective
                            field="driverEmail"
                            headerText="Email"
                            width='100'
                            textAlign='Center'
                            filter={{ type: 'Menu', operator: 'contains' }}
                            allowEditing={false}
                            visible={finalChartChecked}
                        />

                        <ColumnDirective
                            field="driverBankName"
                            headerText="Bank Name"
                            width='100'
                            textAlign='Center'
                            filter={{ type: 'Menu', operator: 'contains' }}
                            allowEditing={false}
                            visible={finalChartChecked}
                        />

                        <ColumnDirective
                            field="driverBankRoutingNumber"
                            headerText="Routing Number"
                            width='100'
                            textAlign='Center'
                            filter={{ type: 'Menu', operator: 'contains' }}
                            allowEditing={false}
                            visible={finalChartChecked}
                        />

                        <ColumnDirective
                            field="driverBankAccountNumber"
                            headerText="Account No"
                            width='100'
                            textAlign='Center'
                            filter={{ type: 'Menu', operator: 'contains' }}
                            allowEditing={false}
                            visible={finalChartChecked}
                        />

                        {/* <ColumnDirective
                            field="rideDate"
                            headerText="Ride Date"
                            width='45'
                            allowEditing={false}
                            textAlign='Center'
                            format='M/d/y'
                            visible={!finalChartChecked}
                        /> */}

                        <ColumnDirective
                            field="totalRides"
                            headerText="Rides"
                            width='40'
                            allowEditing={false}
                            textAlign='Center'
                            visible={!finalChartChecked}
                        />

                        <ColumnDirective
                            field="totalCollectedFare"
                            headerText="Entire Fare ($)"
                            width='55'
                            allowEditing={false}
                            textAlign='Center'
                            visible={!finalChartChecked}
                        />

                        <ColumnDirective
                            columns={[
                                { visible: !finalChartChecked, field: 'totalCardPayment', headerText: 'Card ($)', width: 50, textAlign: 'Center', allowEditing: false },
                                { visible: !finalChartChecked, field: 'totalAppPayment', headerText: 'App ($)', width: 50, textAlign: 'Center', allowEditing: false },
                                { visible: !finalChartChecked, field: 'totalAdvancePayment', headerText: "Account ($)", width: 50, textAlign: 'Center', allowEditing: false }
                            ]}
                            headerText="Digital Payments ($)"
                            textAlign='Center'
                            visible={!finalChartChecked}
                        />


                        <ColumnDirective
                            field="totalDigitalCredits"
                            headerText="Total Digital Fare ($)"
                            width='50'
                            allowEditing={false}
                            textAlign='Center'
                            visible={!finalChartChecked}
                        />

                        <ColumnDirective
                            field="totalCashPayment"
                            headerText="Cash ($)"
                            width='50'
                            allowEditing={false}
                            textAlign='Center'
                            visible={!finalChartChecked}
                        />

                        <ColumnDirective
                            field="beamFee"
                            headerText="Beam Fee ($)"
                            width='45'
                            allowEditing={false}
                            textAlign='Center'
                            visible={!finalChartChecked}
                        />

                        <ColumnDirective
                            field="orgIncome"
                            headerText={`${org} Fee ($)`}
                            width='45'
                            allowEditing={false}
                            textAlign='Center'
                            visible={!finalChartChecked}
                        />


                        <ColumnDirective
                            field="userIncome"
                            headerText={`Driver Income ($)`}
                            width='45'
                            allowEditing={false}
                            textAlign='Center'
                            visible={!finalChartChecked}
                        />

                        {customColumns.flatMap(columnObj =>
                            columnObj.gridColumns.map(column => {
                                const validationRules = getValidationRules(column.type);
                                return (
                                    <ColumnDirective
                                        key={column.key}
                                        field={column.field}
                                        headerText={column.headerText}
                                        width={column.width}
                                        // type='number'
                                        textAlign={column.textAlign}
                                        // format={column.format}
                                        allowEditing={column.allowEditing}
                                        cssClass={column.cssClass}
                                        template={column.template}
                                        validationRules={validationRules}
                                        visible={!finalChartChecked}
                                    />
                                );
                            })
                        )}

                        <ColumnDirective
                            template={balanceAndPayableColumnsCalc}
                            allowEditing={false}
                            headerText='Total Correction' textAlign='Center' width='50'
                            visible={!finalChartChecked}
                        />

                        <ColumnDirective
                            template={balanceAndPayableColumnsCalc}
                            allowEditing={false}
                            headerText='Driver Balance' textAlign='Center' width='50'
                            visible={!finalChartChecked}
                        />

                        <ColumnDirective
                            template={balanceAndPayableColumnsCalc}
                            allowEditing={false}
                            headerText='Driver Payable' textAlign='Center' width='50'
                        />

                    </ColumnsDirective>

                    {aggregatedColumns}

                    <Inject services={[Page, Aggregate, ContextMenu, Group, Sort, Reorder, ExcelExport, CustomSyncfusionFilter, Toolbar, ...((isDayDataOpen===true && isWorkingHours===false) ? [Edit] : [])]} />
                </GridComponent>
            </div>

            <DialogComponent
                header='Confirmation'
                visible={isConfirmationModalOpen}
                width='280px'
                isModal={true}
                content='Do you want to mark the data as final and close the report forever?'
                buttons={[
                    {
                        click: () => handleConfirmation(true),
                        buttonModel: { content: 'Yes', isPrimary: true }
                    },
                    {
                        click: () => handleConfirmation(false),
                        buttonModel: { content: 'No' }
                    }
                ]}
                close={handleDialogClose}
            />

            <AddCustomColumnDialog
                isModalOpen={isModalOpen}
                onClose={handleModalClose}
                onAddColumn={handleAddColumn}
            />

        </div>
    );
}

export default RidesPaymentCalculation;